import type { ProctoringOption } from "@verity/proctoring-option/types";

/**
 * `excludedWebTrafficRecordingUrls` only takes effect while "Record Web Traffic"
 * itself is on. The shared "Add Permitted Websites" list (see
 * OtherActivitiesOptions.tsx's TabWhiteList) can leave it holding data even
 * after Record Web Traffic is unchecked, so a platform-support check must
 * treat that leftover value as inactive rather than as a restriction the new
 * platform will "disable". editQuizHelper.ts already applies this same guard
 * for change-detection; this is the analogous guard for platform support.
 */
export function isOptionInactiveForPlatformCheck(
	key: keyof ProctoringOption,
	option: Partial<ProctoringOption>,
): boolean {
	return key === "excludedWebTrafficRecordingUrls" && !option.recordWebTraffic;
}
